"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.balanceToShares = exports.sharesToBalance = void 0;
const SHARE_OFFSET = 1000n;
const BALANCE_OFFSET = 1000n;
function sharesToBalance(shares, { strategyTotalShares, strategyTotalBalance, }) {
    const virtualShares = strategyTotalShares + SHARE_OFFSET;
    const virtualBalance = strategyTotalBalance + BALANCE_OFFSET;
    return (shares * virtualBalance) / virtualShares;
}
exports.sharesToBalance = sharesToBalance;
function balanceToShares(balance, { strategyTotalShares, strategyTotalBalance, }) {
    const virtualShares = strategyTotalShares + SHARE_OFFSET;
    const virtualBalance = strategyTotalBalance + BALANCE_OFFSET;
    return (balance * virtualShares) / virtualBalance;
}
exports.balanceToShares = balanceToShares;
//# sourceMappingURL=shares-and-balance.js.map